import { render, staticRenderFns } from "./resale.pug?vue&type=template&id=a38542a0&lang=pug&"
import script from "./resale.ts?vue&type=script&lang=ts&"
export * from "./resale.ts?vue&type=script&lang=ts&"
import style0 from "./resale.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports